import { useEffect, useState } from 'react';
import { siteMeta } from '@/mocks/home';

const NAV_ITEMS = [
  { id: 'nav-home', label: '首页', href: '#home' },
  { id: 'nav-hot', label: '深扒榜', href: '#hot' },
  { id: 'nav-topics', label: '主题分类', href: '#topics' },
  { id: 'nav-articles', label: '精选内容', href: '#articles' },
  { id: 'nav-spotlight', label: '深度专题', href: '#spotlight' },
  { id: 'nav-faq', label: '常见问题', href: '#faq' },
  { id: 'nav-about', label: '关于我们', href: '#about' },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200/80'
          : 'bg-gradient-to-b from-foreground-950/70 to-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 max-w-8xl items-center justify-between gap-4 px-4 md:h-[72px] md:px-8">
        <a href="#home" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
            黑
          </span>
          <span className="flex flex-col leading-none">
            <strong
              className={`font-heading text-base font-bold tracking-wide md:text-lg ${
                solid ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              {siteMeta.name}
            </strong>
            <span
              className={`mt-1 text-[10px] tracking-[0.22em] ${
                solid ? 'text-foreground-500' : 'text-background-200'
              }`}
            >
              {siteMeta.tagline}
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.id}
              href={item.href}
              className={`rounded-md px-3 py-2 text-sm whitespace-nowrap transition-colors ${
                solid
                  ? 'text-foreground-700 hover:bg-background-100 hover:text-primary-600'
                  : 'text-background-100 hover:bg-background-50/15 hover:text-background-50'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#contact"
            className="hidden items-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-send-plane-line"></i>
            我要投稿
          </a>
          <button
            type="button"
            aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className={`flex h-10 w-10 items-center justify-center rounded-md border transition-colors lg:hidden ${
              solid
                ? 'border-background-300 text-foreground-800 hover:bg-background-100'
                : 'border-background-50/30 text-background-50 hover:bg-background-50/15'
            }`}
          >
            <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/80 bg-background-50 lg:hidden">
          <nav className="mx-auto max-w-8xl px-4 py-3" aria-label="移动端导航">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.id}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-between rounded-md px-3 py-3 text-sm text-foreground-800 transition-colors hover:bg-background-100"
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setMenuOpen(false)}
              className="mt-2 flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50"
            >
              <i className="ri-send-plane-line"></i>
              我要投稿
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}